import user from './user'
import NotAccessible from '../views/not-accessible'

const context = require.context('../../business', true, /manifest\.js$/)
const manifests = context.keys().map(path => context(path).default)

const transfer = {
  index: 1,
  initRoute(routes, item, parent) {
    let {menu = true, redirect, path, rpath, name, component, loginNotRequired, permission, role, pages} = item
    if (parent) {
      item.index = menu ? ('' + transfer.index++) : parent.index
      item.root = parent.root
      item.parent = parent
      if (!path) item.path = item.index //for el-menu folder
    }
    if (path && component) {
      if (!rpath) rpath = path
      routes.push({path: rpath, component, name, redirect, meta: item})
      if (!loginNotRequired) {
        let meta = {permission, role, menu: false, title: '无权限访问', path: rpath + '/not-accessible'}
        if (parent) Object.assign(meta, {index: item.index, root: item.root, parent: item})
        routes.push({path: rpath + '/not-accessible', component: NotAccessible, meta})
      }
    }
    transfer.initPages(routes, pages, item)
  },
  initModule(routes, modules, item) {
    if (!item) return null
    let {menu = true, redirect, defaultPath, permission, role, pages} = item
    let pass = user.permissionCheck(permission, role)
    item.index = modules.length
    item.menu = menu && pass
    item.root = item
    if (!redirect) redirect = defaultPath
    let n = defaultPath.split('/')[1]
    if (n !== '') routes.push({path: '/' + n, redirect})
    modules.push(item)
    transfer.initPages(routes, pages, item)
    return item
  },
  initPages(routes, pages, parent) {
    if (pages && pages.length > 0) pages.forEach(c => transfer.initRoute(routes, c, parent))
  }
}

const modules = []
const initConfig = () => {
  let commonRoutes = [], consoleRoutes = []
  manifests.forEach(({module, pages}) => {
    let parent = transfer.initModule(consoleRoutes, modules, module)
    transfer.initPages(commonRoutes, pages, parent)
  })
  return {commonRoutes, consoleRoutes}
}

export {initConfig, modules}